/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import procedureDivorceSectionStyle from "./procedureDivorceSectionStyle";
import Grid from "@mui/material/Grid";
import Container from "../../../Container/Container";
import TextContainer from "../../../Container/TextContainer";
import IconDocument from "../../../../assets/icons/generic/IconDocument";
import IconDocumentVv from "../../../../assets/icons/serviceOverview/IconDocumentVv";
import IconCourt from "../../../../assets/icons/serviceOverview/IconCourt";
import Typography from "@mui/material/Typography";
import GradientPaper from "../../../GradientComponents/GradientPaper";
import { Box, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import IconWrapper from "../../../IconWrapper/IconWrapper";

type ProcedureDivorceSectionProps = {
  headline?: string;
  iconOverwrites?: string[] | React.ComponentType<{ sx?: SxProps<Theme> }>[];
};

const ProcedureDivorceSection = ({ headline = "Der Ablauf einer Scheidung bei Legalbird", iconOverwrites = [] }: ProcedureDivorceSectionProps) => {
  const theme = useTheme();

  return (
    <>
      <Container sx={procedureDivorceSectionStyle.centered}>
        <Box sx={procedureDivorceSectionStyle.scrollToAnchor} id="ablauf">
          {" "}
        </Box>
        <Typography variant={"h2"}>{headline}</Typography>
      </Container>
      <div>
        <TextContainer sx={procedureDivorceSectionStyle.centered}>
          <Grid container>
            <Grid item xs={12}>
              <GradientPaper sx={procedureDivorceSectionStyle.paper}>
                <Grid container sx={procedureDivorceSectionStyle.gridContainer}>
                  <Grid item xs={12} sm={4}>
                    <GetIconComponent iconOverwrites={iconOverwrites[0]} defaultIcon={IconDocument} sx={procedureDivorceSectionStyle.icon(theme)} />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>1. Scheidungsformular</Typography>
                    <p>Sie füllen innerhalb von 5 Minuten online das Formular aus</p>
                  </Grid>
                </Grid>
                <Grid container sx={procedureDivorceSectionStyle.gridContainer}>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>2. Scheidungsantrag</Typography>
                    <p>Wir erstellen den Antrag für Sie und reichen ihn bei Gericht ein</p>
                  </Grid>
                  <Grid item xs={12} sm={4} sx={procedureDivorceSectionStyle.gridItemReversed}>
                    <GetIconComponent iconOverwrites={iconOverwrites[1]} defaultIcon={IconDocumentVv} sx={procedureDivorceSectionStyle.icon(theme)} />
                  </Grid>
                </Grid>
                <Grid container sx={procedureDivorceSectionStyle.gridContainer}>
                  <Grid item xs={12} sm={4}>
                    <GetIconComponent iconOverwrites={iconOverwrites[2]} defaultIcon={IconCourt} sx={procedureDivorceSectionStyle.icon(theme)} />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>3. Scheidungstermin</Typography>
                    <p>Das Gericht weist Ihnen einen Scheidungstermin zu und Sie werden geschieden</p>
                  </Grid>
                </Grid>
                <Typography variant={"h4"} sx={procedureDivorceSectionStyle.questions}>
                  Sie haben Fragen?
                </Typography>
                <p>Nach Ihrer Registrierung rufen wir Sie zeitnah an, um alle offenen Fragen zu klären und wir beraten Sie persönlich zu Ihrer Scheidung!</p>
              </GradientPaper>
            </Grid>
          </Grid>
        </TextContainer>
      </div>
    </>
  );
};

const GetIconComponent = ({
  defaultIcon,
  sx = {},
  iconOverwrites,
}: {
  defaultIcon: string | React.ComponentType<{ sx?: SxProps<Theme> }>;
  sx?: SxProps;
  iconOverwrites?: string | React.ComponentType<{ sx?: SxProps<Theme> }>;
}) => {
  const IconComponent = iconOverwrites ? iconOverwrites : defaultIcon;
  return <IconWrapper icon={IconComponent} sx={sx} />
};

export default ProcedureDivorceSection;
